"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListItem = void 0;
/*---------------------------------------------------------------------------------------------
 * Copyright (c) Bentley Systems, Incorporated. All rights reserved.
 * See LICENSE.md in the project root for license terms and full copyright notice.
 *--------------------------------------------------------------------------------------------*/
const React = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const index_js_1 = require("../utils/index.js");
require("@itwin/itwinui-css/css/menu.css");
const ListItemComponent = React.forwardRef((props, ref) => {
    const { as: Element = 'li', size = 'default', disabled = false, active = false, actionable = false, focused = false, className, ...rest } = props;
    (0, index_js_1.useTheme)();
    return (React.createElement(Element, { className: (0, classnames_1.default)('iui-list-item', className), "data-iui-active": active ? 'true' : undefined, "data-iui-disabled": disabled ? 'true' : undefined, "data-iui-size": size === 'large' ? 'large' : undefined, "data-iui-actionable": actionable ? 'true' : undefined, "data-iui-focused": focused ? 'true' : undefined, ref: ref, ...rest }));
});
// ----------------------------------------------------------------------------
const ListItemIcon = React.forwardRef((props, ref) => {
    const { as: Element = 'div', className, ...rest } = props;
    return (React.createElement(Element, { className: (0, classnames_1.default)('iui-list-item-icon', className), ref: ref, ...rest }));
});
// ----------------------------------------------------------------------------
const ListItemContent = React.forwardRef((props, ref) => {
    const { as: Element = 'div', className, ...rest } = props;
    return (React.createElement(Element, { className: (0, classnames_1.default)('iui-list-item-content', className), ref: ref, ...rest }));
});
// ----------------------------------------------------------------------------
const ListItemDescription = React.forwardRef((props, ref) => {
    const { as: Element = 'div', className, ...rest } = props;
    return (React.createElement(Element, { className: (0, classnames_1.default)('iui-list-item-description', className), ref: ref, ...rest }));
});
// ----------------------------------------------------------------------------
// Exported compound component
/**
 * A generic ListItem component that can be used simply for displaying data, or as a base
 * for the list items in a more complex component (e.g. a custom Select).
 *
 * Includes support for left/right icons, multiple lines of text, and hover/focus/active/disabled styling.
 *
 * @example
 * <List>
 *   <ListItem>item 1</ListItem>
 *   <ListItem>item 2</ListItem>
 *   <ListItem>item 3</ListItem>
 * </List>
 */
exports.ListItem = Object.assign(ListItemComponent, {
    /**
     * Icon to be placed at the beginning or end of the ListItem.
     */
    Icon: ListItemIcon,
    /**
     * Wrapper for the main content of the ListItem.
     *
     * For basic list items, this wrapper is not needed, but it can be useful for two cases:
     * - When using an end icon. The `ListItem.Content` will fill the available space
     *   and push the icon to the end
     * - When using `ListItem.Description`.
     */
    Content: ListItemContent,
    /**
     * Description to be used in addition to the main label of the ListItem.
     * Should be used as a child of `ListItem.Content`.
     *
     * @example
     * <ListItem>
     *  <ListItem.Content>
     *   <div>some list item</div>
     *   <ListItem.Description>description for this item</ListItem.Description>
     *  </ListItem.Content>
     * </ListItem>
     */
    Description: ListItemDescription,
});
